import FacturasGlobalesListStore from './FacturasGlobalesListStore';
import FacturasGlobalesInfoStore from './FacturasGlobalesInfoStore';

const FacturasGlobalesStore = {
  list: FacturasGlobalesListStore,
  info: FacturasGlobalesInfoStore,
};

export default FacturasGlobalesStore;
